export function getMobileAppType() {
    var _a, _b, _c, _d, _e;
    const isMobileApp = (_c = (_b = (_a = window.RestaumaticMobileApp) === null || _a === void 0 ? void 0 : _a.isMobileApp) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : false;
    if (!isMobileApp) {
        return null;
    }
    const appType = (_e = (_d = window.RestaumaticMobileApp) === null || _d === void 0 ? void 0 : _d.getAppType) === null || _e === void 0 ? void 0 : _e.call(_d);
    return appType === "IosMobileApp" ? "IosApp" : "AndroidApp";
}
